import { LocallyAugmentedExample } from '@/types/LocallyAugmentedExample';
import CheatList from './CheatList';
import SearchResultsHeading from './SearchResultsHeading';

interface SearchResultsProps {
  searchTerm: string;
  loading: boolean;
  results: LocallyAugmentedExample[];
}

const SearchResults = (props: SearchResultsProps) => {
  const { searchTerm, loading, results } = props;

  return (
    <div className="pt-4">
      <SearchResultsHeading
        searchTerm={searchTerm}
        loading={loading}
        resultsLength={results.length}
      />
      <CheatList cheats={results} clickable showDifficulty={false} />
    </div>
  );
};

export default SearchResults;
